import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { HIUser } from '../../core/HIUser';
import { PhoneNumber } from 'src/app/customer/PhoneNumber';
import { DataService } from 'src/app/core/data.service';
import { TelephoneTypes } from '../TelephoneTypes';
import { CustomAuthService } from 'src/app/auth.service';

@Component({
  selector: 'user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent {
    @Output() modifiedUser: EventEmitter<HIUser> = new EventEmitter();
    @Input()
    set user(user: HIUser) {
        if (this.currentUser || !user.sid) {
            return;
        }
        if (!user) {
            user = new HIUser();
        }
        this.currentUser = user;
        this.addUserForm.patchValue(user);
        user.telephoneNumbers.forEach( tel =>
            this.phoneNumberArray.push(this.formBuilder.group({
                sid: [tel.sid],
                type: [tel.type],
                number: [tel.number]
            }))
        );
        if (user.sid && user.sid != this.authService.getUserSid()) {
            this.displayDelete = true;
        }
    }
    displayDelete = false;
    currentUser: HIUser;
    addUserForm: FormGroup;
    phoneNumberTypes = TelephoneTypes;
    phoneNumberTypesKeys: any[];

    constructor(
        private formBuilder: FormBuilder,
        public authService: CustomAuthService,
        private dataService: DataService) {
    this.phoneNumberTypesKeys = Object.keys(this.phoneNumberTypes).filter(x => String(x).length > 2);

    this.buildUserForm();
  }

  buildUserForm() {
    this.addUserForm = this.formBuilder.group({
       title: ['', Validators.required],
       firstName: ['', Validators.required],
       surname: ['', Validators.required],
       email: ['', Validators.required],
       streetAddress: [''],
       town: [''],
       postCode: [''],
       phoneNumberArray: this.formBuilder.array([])
   });
 }


  createPhoneNumberArray(): FormGroup {
    return this.formBuilder.group({
        sid: [''],
        type: TelephoneTypes[''],
        number: ['']
    });
  }

  get phoneNumberArray() {
    return this.addUserForm.get('phoneNumberArray') as FormArray;
  }

  saveUser() {
    const toSave = new HIUser();

    toSave.firstName = this.addUserForm.get('firstName').value;
    toSave.title = this.addUserForm.get('title').value;
    toSave.email = this.addUserForm.get('email').value;
    toSave.surname = this.addUserForm.get('surname').value;
    toSave.town = this.addUserForm.get('town').value;
    toSave.streetAddress = this.addUserForm.get('streetAddress').value;
    toSave.telephoneNumbers = [];
    toSave.postCode = this.addUserForm.get('postCode').value;
    for (const phoneNumber of this.phoneNumberArray.controls) {
        const newNumber: PhoneNumber = new PhoneNumber(phoneNumber.value.sid, phoneNumber.value.number, phoneNumber.value.type);
        toSave.telephoneNumbers.push(newNumber);
    }
    if (this.currentUser && this.currentUser.sid) {
        toSave.sid = this.currentUser.sid;
        this.dataService.callPut('user', JSON.stringify(toSave)).subscribe(
            () => {
                this.modifiedUser.next(toSave);
            },
            error => {
              console.log(error);
            }
        );
    } else {
        this.dataService.callPostAndGet('user', JSON.stringify(toSave)).subscribe(
        newUser => {
            this.modifiedUser.next(newUser);
        },
        error => {
            console.log(error);
        }
        );
    }
  }

  addItem() {
    this.phoneNumberArray.push(this.createPhoneNumberArray());
 }

    removeItem(index: number) {
        this.phoneNumberArray.removeAt(index);
    }
    deleteUser() {
        this.dataService.callDelete('user/' + this.currentUser.sid).subscribe(
          () => {
            this.modifiedUser.next(null);
          },
          error => {
            console.log(error);
          }
        );
      }
    close() {
        this.modifiedUser.next(this.currentUser);
    }
}
